import React, {useState} from 'react';
import {connect} from 'react-redux';
import {Button, refreshView} from 'react-admin';
import axiosInstance from "../../api/axios";
import {showErrorNotify, showSuccessNotify} from "../../components";
import Swal from "sweetalert2";
import {CircularProgress} from "@material-ui/core";

const CardApplicationSyncButton = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    function onSubmit() {
        Swal.fire({
            title: 'Xác nhận',
            text: `Dữ liệu đã chọn sẽ được tạo đơn mở thẻ theo lô mới nhất?`,
            type: "warning",
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonColor: '#d33',
            focusConfirm: false,
        }).then(async (result) => {
            if (result.value) {
                setIsLoading(true)
                const url = `/api/eduDatas/syncInternal`;
                axiosInstance.put(url, props.selectedIds).then(rs => {
                    setIsLoading(false)
                    if (rs.data.success) {
                        showSuccessNotify("Tạo đơn mở thẻ thành công");
                        window.location.reload()
                        return;
                    }
                    if (rs.data?.error?.message) {
                        showErrorNotify(rs.data?.error?.message);
                    } else {
                        showErrorNotify("Có lỗi xảy ra, vui lòng thử lại hoặc liên hệ quản trị viên");
                    }
                }, err => {
                    setIsLoading(false)
                    showErrorNotify("Có lỗi xảy ra, vui lòng thử lại hoặc liên hệ quản trị viên");
                });
            }
        })
    }

    return (<>
        {isLoading && <CircularProgress style={{marginRight: 10}} color="secondary"/>}
            <Button variant="outlined" label="Tạo mở thẻ" disabled={isLoading} onClick={onSubmit}/>
    </>

    );
}

export default connect(null, {refreshView})(
    CardApplicationSyncButton
);

